import { Flex } from "Element/Flex";
import styled from "styled-components";

export const RoadmapWrapper = styled.div`
  padding: 72px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 72px 24px;
  `}
`;

export const Timeline = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 1200px;
  ::after {
    content: "";
    position: absolute;
    width: 12px;
    background-color: ${({ theme }) => theme.colors.neutral20};
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -3px;
    border-radius: 12px;
  }
`;

export const Container = styled.div`
  padding: 0 40px 24px;
  position: relative;
  width: 50%;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: fit-content;
    max-width: 400px;
    width: 100%;

    border-radius: 8px;
    padding: 0 0 80px;
    :last-child{
      padding: 0;
      ::after{
        height: 100%;
      }
    }
  `}
`;

export const ContainerLeft = styled(Container)<{ ok: boolean }>`
  left: 0;
  ::after {
    content: "";
    position: absolute;
    width: 12px;
    border-radius: 12px;
    background-color: ${({ theme, ok }) =>
      ok ? theme.colors.primary40 : "transparent"};
    top: 0;
    bottom: 0;
    left: 100%;
    margin-left: -3px;
    margin-top: -10px;
    z-index: 2;
    height: 120%;
    ${({ theme }) => theme.mediaWidth.upToMedium`
      height: 101%;
      margin-top: 0;
      left: 50%;
      :last-child{
        height: 100%;
      }
    `}
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 auto;
  `}
`;
export const ContainerRight = styled(Container)<{ ok: boolean }>`
  left: 50%;
  ::after {
    content: "";
    position: absolute;
    width: 12px;
    border-radius: 12px;
    background-color: ${({ theme, ok }) =>
      ok ? theme.colors.primary40 : "transparent"};
    top: 0;
    bottom: 0;
    left: 0;
    margin-left: -3px;
    margin-top: -10px;
    z-index: 2;
    height: 120%;
    ${({ theme }) => theme.mediaWidth.upToMedium`
      height: 101%;
      margin-top: 0;
      left: 50%;
    `}
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 auto;
    left: 0;
  `}
`;

export const ContainerContent = styled.div<{ idx: number }>`
  padding: 0 24px 24px;
  position: relative;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: ${({ idx }) => (idx % 2 === 0 ? "right" : "left")};
  z-index: 3;
  justify-content: end;
  ${({ theme, idx }) => theme.mediaWidth.upToMedium`
    background-color: ${theme.colors.neutral20};
    flex-direction: ${idx % 2 === 0 ? "column-reverse" : "column"};
    text-align: center;
    padding: 24px;
  `}
`;

export const ContentWrapper = styled(Flex)<{ idx: number }>`
  h2 {
    margin-bottom: 16px;
  }
  ${({ idx }) => (idx % 2 === 0 ? "margin-right: 24px" : "margin-left: 24px")};
  ${({ theme, idx }) => theme.mediaWidth.upToMedium`
    margin: 24px 0 0;
  `}
`;

export const StyledUl = styled.ul`
  padding: 0;
  margin: 0;
  li {
    margin-bottom: 8px;
    list-style-position: inside;
  }
`;
